import React, { useMemo } from 'react';
import IconButton, { IconButtonProps } from '@shared/ui/molecules/icon-button/IconButton';
import { canUserEditTeam } from "@shared/utils/AccessControl";
import { useDispatch, useSelector } from "react-redux";
import { redirectTo, selectCurrentUser } from "@shared/store/auth.duck";
import { TeamEntity } from '@shared/models/team.models';
import { Column } from '@shared/ui/atoms/StructuralLayout';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import styled from "styled-components";
import { desktopSmall } from '@shared/ui/atoms/MediaQueries';
import { deepLinkTo, isInTeams } from "@shared/utils/TeamsUtils";
import { teamsTabs, uiUrl } from "@shared/services/EnvironmentVariables";
import { IconTypes } from '@shared/ui/atoms/icon/Icon';

interface Props {
  team?: TeamEntity;
  visible?: boolean;
  showTeamDetails: boolean;
}

export function EditTeamControlsRow(props: Props) {
  const dispatch = useDispatch();
  const {team} = props;
  const current = useSelector(selectCurrentUser);
  const enableEditTeamButton = useMemo(() => canUserEditTeam(current, team), [current, team]);

  const onEditTeamClick = () => {
    if (!team?.id) return;

    if (isInTeams()) {
      const externalUrl = `${uiUrl}/manage/team/${team.id}`
      deepLinkTo(teamsTabs.settings, externalUrl, 'team', team.id);
    } else {
      dispatch(redirectTo(`/manage/team/${team.id}`))
    }
  }

  if (!team || props.visible) {
    return null;
  }

  return (
    <Row>
      {props.showTeamDetails && <Column>
        <BodyRegular weight={600}>{team.name}</BodyRegular>
      </Column>}

      {enableEditTeamButton && <EditButton dataTest="editTeamButton" onClick={onEditTeamClick} icon={IconTypes.Edit} text="edit-team.title"/>}
    </Row>
  )
}

const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  margin-top: 8px;
  @media (${desktopSmall}) {
    margin-top: 0;
    padding: 16px;
  }
`

const EditButton = styled(IconButton)<IconButtonProps>`
  justify-self: flex-end;
  margin-left: auto;
  i {
    font-size: 30px;
  }
`
